export const accessLog = {
    title: {
        accessLogPage: 'Access Log Page',
    },
    accessLogList: {
        username: 'LDAP Username',
        email: 'Email',
        country: 'Country',
        city: 'City',
        module: 'Module',
        company: 'Company',
        phone: 'Phone',
        loginAt: 'Login Date and Time',
        logoutAt: 'Logout Date and Time',
        duration: 'Duration',
    },

    filterForm: {
        keyword: {
            label: 'Keyword',
            placeholder: 'Enter keyword',
        },
        loginAtRange: {
            label: 'Login At',
            to: 'to',
            startDate: 'Start Date',
            endDate: 'End Date',
        },
        module: {
            label: 'Access Module',
            placeholder: 'Select Access Module',
        },
        company: {
            label: 'Company',
            placeholder: 'Select Company',
            selectBlank: 'Blank',
            selectAllCompany: 'All Company',
        },
    },
    breadcrumb: {
        accessLog: 'Access log',
        userLog: 'User log',
    },
};
